<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Search</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <div class="card mb-3">
          <div class="card-body">
            <form novalidate @submit.prevent="search">
              <inputbox
                name="query"
                v-model="query"
                placeholder="Search..."
                :stacked="true"
              >
                <div slot="rightBtn">
                  <form-button :indicator="indicator" @clicked="search"
                    >Search Claims
                  </form-button>
                </div>
              </inputbox>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-3">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Claim Reference</th>
                  <th>Client Name</th>
                  <th>Client Vehicle Registration</th>
                  <th>Third Party</th>
                  <th>Third Party Insurer</th>
                  <th>Handler</th>
                  <th>Incident Date</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(result, index) in results" v-bind:key="index">
                  <td>
                    {{
                      result.source.claim_reference
                        ? result.source.claim_reference
                        : 'Not Available'
                    }}
                  </td>
                  <td>
                    {{
                      result.client
                        ? result.client.full_name
                          ? result.client.full_name
                          : 'Not Available'
                        : 'Not Available'
                    }}
                  </td>
                  <td>
                    {{
                      result.client
                        ? result.client.vehicle
                          ? result.client.vehicle.registration
                          : 'Not Available'
                        : 'Not Available'
                    }}
                  </td>
                  <td>
                    {{
                      result.third_parties.length
                        ? result.third_parties[0].full_name
                          ? result.third_parties[0].full_name
                          : 'Not Available'
                        : 'Not Available'
                    }}
                  </td>
                  <td>
                    {{
                      result.third_parties.length
                        ? result.third_parties[0].insurer
                          ? result.third_parties[0].insurer.name
                          : 'Not Available'
                        : 'Not Available'
                    }}
                  </td>
                  <td>
                    {{ result.handler?.full_name }}
                  </td>
                  <td>
                    {{ result.source?.incident_occurred_at | date }}
                  </td>
                  <td>
                    <button
                      class="btn btn-primary"
                      v-on:click.prevent="view(result)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card mb-3" v-if="invoiceResults.length">
          <div class="card-header">
            <h4 class="card-title">Invoices</h4>
          </div>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Claim Reference</th>
                <th>Invoice Number</th>
                <th>Client Name</th>
                <th>Client Vehicle Registration</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(result, index) in invoiceResults" :key="index">
                <td>
                  {{
                    result.recovery?.incident?.source?.claim_reference ||
                      'Not Available'
                  }}
                </td>
                <td>
                  {{ result.invoice_number || 'Not Available' }}
                </td>
                <td>
                  {{
                    result.recovery?.incident?.client?.full_name ||
                      'Not Available'
                  }}
                </td>
                <td>
                  {{
                    result.recovery?.incident?.client?.vehicle?.registration ||
                      'Not Available'
                  }}
                </td>
                <td>
                  <router-link
                    :to="'/recovery/' + result.recovery?.incident?.identifier"
                    class="btn btn-primary"
                  >
                    View
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './Modules/Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      query: null,
      results: [],
      invoiceResults: [],
      indicator: false
    };
  },

  mounted() {},

  methods: {
    search() {
      if (this.query && this.query.length) {
        this.indicator = true;
        window.Ajax.post(`/search`, { terms: this.query })
          .then(response => {
            this.results = response.data.incidents;
            this.invoiceResults = response.data.invoices;

            this.indicator = false;

            if (!!this.results.length && !this.invoiceResults) {
              window.swal(
                'No results found',
                'We could not find any results',
                'error'
              );
            }
          })
          .catch(error => {
            this.indicator = false;
          });
      } else {
        window.swal('Error', 'Please enter a search term', 'error');
      }
    },

    view(result) {
      this.$router.push(this.incidentUrl(result));
    }
  }
};
</script>
